(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/store.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/store.js');
"use strict";


svs.challenge.store = svs.utils.reactHelpUtils.createStore(svs.challenge.reducers.Reducer, svs.challenge.data.initialState, [svs.challenge.middleware.localStorageMiddleware]);

svs.components.Storage.browser.get(svs.challenge.constants.LOCAL_STORAGE_SETTINGS_NAME, svs.challenge.constants.LOCAL_STORAGE_DOMAIN, data => {
  if (data && data.settings) {
    const storedSettings = data.settings;
    if (storedSettings) {
      svs.challenge.store.dispatch(svs.challenge.actions.loadSettingsFromLocalStorage({
        settings: storedSettings
      }));
    }
  }
});
svs.challenge.isCurrentCouponPayable = (state, drawNumber) => svs.challenge.getBoardData(state, drawNumber).valid;

svs.challenge.getBoardData = (state, drawNumber) => {
  const draw = svs.challenge.helpers.getDrawByDrawNumber(drawNumber, state);
  const coupon = svs.challenge.helpers.getCouponByDrawNumber(state, drawNumber);
  const nrOfRows = coupon.drawEvents.length;
  const boardData = new Array(nrOfRows);

  for (let i = 0; i < boardData.length; ++i) {
    boardData[i] = '';
  }
  let nrOfValidRows = 0;
  const clickInterpret = row => {
    let retStr = '';
    row.forEach((value, i) => {
      if (i == 1 && value == true) {
        retStr += '1';
      } else if (i == 2 && value == true) {
        retStr += 'X';
      } else if (i == 4 && value == true) {
        retStr += '2';
      }
    });
    return retStr;
  };
  coupon.drawEvents.forEach((row, i) => {
    boardData[i] += clickInterpret(row);
    const filled = row.join(',') != 'false,false,false,false,false';
    if (filled) {
      nrOfValidRows++;
    }
  });
  boardData.shift();
  const multiInterpret = () => {
    const chosenBetPrice = parseInt(coupon.chosenBetPrice, 10);
    const minRowPrice = parseInt(draw.rowPrice, 10);
    return chosenBetPrice / minRowPrice;
  };
  return {
    betSum: coupon.betSum,
    boardData,
    drawNumber,
    rowPriceMulti: multiInterpret(),
    systemType: coupon.systemType,
    valid: nrOfValidRows === nrOfRows - 1
  };
};
svs.challenge.selectors.isCouponEmpty = (state, drawNumber) => {
  const _state$coupons$find = state.coupons.find(coupon => coupon.drawNumber === drawNumber),
    drawEvents = _state$coupons$find.drawEvents;
  for (let i = 0; i < drawEvents.length; ++i) {
    if (drawEvents[i].indexOf(true) > 0) {
      return false;
    }
  }
  return true;
};

 })(window);